export default {
  collectors: [],
  userCollectors: [],
  timeouts: [],
};
